import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M3.237 3.26c.163-.311 4.311 2.609 6.071 5.122a.176.176 0 0 0 .311-.047c.365-1.117.99-3.922-1.082-5.854C6.7.768 3.268.3 1.385.166A1.28 1.28 0 0 0 .013 1.638c.26 1.868.97 5.262 2.809 6.973a4.6 4.6 0 0 0 3.225 1.226 7 7 0 0 0 1.711-.231.26.26 0 0 0 .176-.161.26.26 0 0 0-.034-.236C6.486 7.227 3.1 3.519 3.237 3.26"
    }, null, -1)
  ]));
}
const natureEcologyLeaf = { render };
export {
  natureEcologyLeaf as default,
  render
};
//# sourceMappingURL=nature-ecology-leaf.svg.js.map
